import { Box, Typography, Link, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, CircularProgress } from '@mui/material'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { Link as RouterLink, useLocation } from 'react-router-dom'

import TermsOfferBanner from '~/components/Terms/OfferBanner/TermsOfferBanner'
import application from '~/config/application'
import Scan2RecyclePromotion from '~/domain/Promotion/Scan2RecyclePromotion'
import type { RootState } from '~/redux/reducers/root'
import { ROUTE_ACCOUNT } from '~/routes/Routes'
import type { LocationState } from '~/types/location/Location'

import GB from './GB'
import IE from './IE'
import BlisterGB from './BlisterGB'

const TermsView: React.FC = () => {
  const location = useLocation()
  const isAuthenticating = useSelector((state: RootState) => state.auth.isAuthenticating)

  if (isAuthenticating) {
    return <Box sx={{ display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'center' }}>
      <CircularProgress />
    </Box>
  }

  return <>
    <Helmet>
      <title>Terms & Conditions | Recycle at Boots</title>
    </Helmet>
    {(location?.state as LocationState)?.from === ROUTE_ACCOUNT && <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 2 }}>
      <Link component={RouterLink} to={ROUTE_ACCOUNT}>Account</Link>
      <Typography
        sx={{ display: 'flex', alignItems: 'center' }}
        color="text.primary"
      >Terms & Conditions</Typography>
    </Breadcrumbs>}
    <Box>
      <Box>
        <Typography variant="h4" sx={{ mt: 2 }} gutterBottom>
          Terms & Conditions
        </Typography>
        <TermsOfferBanner />
        <Typography variant="h6">RECYCLE AT {application.client.toUpperCase()} - CUSTOMER TERMS & CONDITIONS</Typography>
      </Box>
      <Box sx={{ my: 2 }}>
        <Accordion sx={{ '&:before': { display: 'none' } }} defaultExpanded={Scan2RecyclePromotion.country === 'GB' && Scan2RecyclePromotion.scheme.shortName === 'Beauty'}>
          <AccordionSummary>
            <Typography variant='h5'>Boots Health & Beauty Recycling GB</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <GB />
          </AccordionDetails>
        </Accordion>
        <Accordion defaultExpanded={Scan2RecyclePromotion.country === 'IE'}>
          <AccordionSummary>
            <Typography variant='h5'>Boots Health & Beauty Recycling IE</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <IE />
          </AccordionDetails>
        </Accordion>
        <Accordion sx={{ '&:before': { display: 'none' } }} defaultExpanded={Scan2RecyclePromotion.country === 'GB' && Scan2RecyclePromotion.scheme.shortName === 'Blister'}>
          <AccordionSummary>
            <Typography variant='h5'>Boots Blister Pack Recycling GB</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <BlisterGB />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  </>
}

export default TermsView
